<template>
  <b-col>
    <b-row align-v="center" align-h="center">

      <b-col cols="6">
        <img :src="image" :alt="alt" class="mt-1 c308-image ">
      </b-col>

      <b-col cols="6">
        <slot name="p-1"/>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col cols="6">
        <slot name="p-2"/>
      </b-col>

      <b-col cols="6">
        <slot name="p-3"/>
      </b-col>
    </b-row>

  </b-col>
</template>

<script>
export default {
  name: "C308",
  props: {
    image: {
      default: 'https://picsum.photos/1280/720'
    },
    alt: {
      default: 'mix it web'
    }
  }
}
</script>

<style scoped>
.c308-image {
  width: 112px !important;
  height: 112px;
}
</style>